import { observer } from "mobx-react-lite";
import React from "react";

import { CustomiserSwitchOption } from "../types";
import Switch from "./Switch";

const CustomiserSwitchList = observer(
  (props: {
    items: CustomiserSwitchOption[];
    selected: CustomiserSwitchOption[];
    onClickOption: (option: CustomiserSwitchOption) => void;
  }) => {
    const renderContainer = (children: JSX.Element): JSX.Element => {
      return <div className={"pyht-customiser-switch-list"}>{children}</div>;
    };

    return renderContainer(
      <>
        {props.items.map((option, optionIndex) => {
          return (
            <div className={"option-item"} key={optionIndex}>
              <div className={"option-switch"}>
                <Switch
                  active={
                    props.selected &&
                    props.selected.map((item) => item.id).indexOf(option.id) >
                      -1
                  }
                  onClick={() => props.onClickOption(option)}
                />
              </div>
              <span className={"option-title"}>{option.label}</span>
              <span className={"option-price"}>
                {option.included
                  ? "Included"
                  : "$" + option.price.toLocaleString()}
              </span>
            </div>
          );
        })}
      </>
    );
  }
);

export default CustomiserSwitchList;
